import {TFilter} from 'plugins/modules/filter/types';
import {useEffect, useState} from 'react';

const getUpdatedFilters = (filterList: TFilter[], filterCodes: string[]): TFilter[] => {
    if (!filterCodes.length) {
        return filterList;
    }

    return filterList.filter((filter) => {
        return !filterCodes.includes(filter.code);
    });
};

export const useUpdatedFilterList = (filterList: TFilter[], filterCodes: string[]): TFilter[] => {
    const [resultFilters, setResultFilters] = useState<TFilter[]>(filterList);

    useEffect(() => {
        const updatedFilters = getUpdatedFilters(filterList, filterCodes);

        const isDifferent = JSON.stringify(resultFilters) !== JSON.stringify(updatedFilters);

        if (isDifferent) {
            setResultFilters(updatedFilters);
        }
    }, [filterList, filterCodes, resultFilters]);

    return resultFilters;
};
